<template>
    <project-step-container
            prev-to="be_go_broad_to_go_narrow_11"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text " tabindex="0">
                 {{getMessage(12, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(12, 'who')}}</label>
                <input id="first-thing" type="text" v-model="form.who"
                :placeholder="getMessage(12, 'whoplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(12, 'rounds')}}</label>
                <input id="second-thing" type="text" v-model="form.rounds"
                :placeholder="getMessage(12, 'roundsplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(12, 'ideas')}}</label>
                <input id="third-thing" type="text" v-model="form.ideas" 
                :placeholder="getMessage(12, 'ideasplaceholder')"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "GoBroadToGoNarrow12",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_BRAINSTORMING,
                urlNextProject:'be_go_broad_to_go_narrow_13',
                form: {
                    who: "",
                    rounds: "",
                    ideas: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

